import React, { FC } from "react";
import type { EndUserAppsIndividualTransfersProps } from "@/types";
import { Image } from "../image";
import { TextCols } from "../text-cols";

export const EndUserAppsIndividualTransfers: FC<
  EndUserAppsIndividualTransfersProps
> = ({ content, cover }) => {
  return (
    <section className="endUserAppsIndividualTransfers">
      <div className="endUserAppsIndividualTransfers--inner">
        <div className="wrapper">
          <TextCols content={content} maxTitleWidth={700} />
        </div>
        <div className="wrapper wrapper_lg">
          {cover.file?.url && (
            <Image
              className="endUserAppsIndividualTransfers--cover"
              src={cover as any}
              alt={cover.title}
              animateInView
            />
          )}
        </div>
      </div>
    </section>
  );
};
